export function generateCodeUrl(code: any) {
  return code?.map((c: any) => `code[]=${c}&`).join("");
}

export function generateTrayNameUrl(code: any) {
  return code.map((c: any) => `trayName[]=${c}&`).join("");
}
